const settings = JSON.parse(window.appSettings);
export default function getSetting(key, defaultValue = null) {
    if (!settings.hasOwnProperty(key)) {
        settings[key] = defaultValue;
    }
    return settings[key];
}

export const getSettings = () => settings;

export const getCurrency = symbol => {
    return settings.currencies[symbol];
}
